/**
 * Rep ramp date rule: a new hire gets their book on the first Friday of the first
 * full Mon–Fri workweek (i.e. the first Friday on/after the 5th) of the target month.
 *   - Start on the 1st–14th  → target month is the NEXT month.
 *   - Start on the 15th–31st → target month is the month AFTER NEXT.
 * Examples: start Jan 14, 2026 → Fri Feb 6, 2026; start Jan 18, 2026 → Fri Mar 6, 2026.
 */
export function rampDateFor(startIso?: string | null): string | null {
  if (!startIso || !Number.isFinite(Date.parse(`${startIso}T00:00:00Z`))) return null;
  const start = new Date(`${startIso}T00:00:00Z`);
  const monthsAhead = start.getUTCDate() <= 14 ? 1 : 2;
  const d = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth() + monthsAhead, 5));
  d.setUTCDate(5 + ((5 - d.getUTCDay() + 7) % 7)); // first Friday on/after the 5th
  return d.toISOString().slice(0, 10);
}
